import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-logo">
            <h3>Millennium Model School</h3>
            <img src="/logo/logo.jpg" alt="Millennium Model School Logo" className="footer-logo-image" />
          </div>

          <div className="footer-section footer-contact">
            <h4>Contact</h4>
            <div className="contact-info">
              <div className="contact-item">
                <strong>Address:</strong>
                <p>Millennium Model School<br />
                Khajrod Road, Mandi Bamora, M.P.</p>
              </div>
              <div className="contact-item">
                <strong>Email:</strong>
                <p>
                  <a href="mailto:millenniummodel2000@gmail.com">
                    millenniummodel2000@gmail.com
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <strong>Phone:</strong>
                <p>
                  <a href="tel:+919926336071">+91-9926336071</a>,{' '}
                  <a href="tel:+918982352628">+91-8982352628</a>
                </p>
              </div>
            </div>
          </div>

          <div className="footer-section footer-map">
            <h4>Location</h4>
            <div className="map-container">
              <iframe
                title="Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3643.1240516105204!2d78.08112467544213!3d24.061935678459104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3979678bd2b7e55b%3A0x216132c20b2b6013!2sMillennium%20Model%20School!5e0!3m2!1sen!2sin!4v1691687388183!5m2!1sen!2sin"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Millennium Model School. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

